export default __webpack_public_path__ + "static/hero_maid_mobile-e0b20bd93b51ac1b9f8b418ab65dda54.webp";